(function () {
  var ROOT_SELECTOR = '[data-noir-configurator]';
  var STORAGE_KEY = 'noirConfiguratorDraft';

  function cssEscape(value) {
    return value.replace(/(["\\\]\[])/g, '\\$1');
  }

  function trackEvent(name, detail) {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    }
  }

  function initConfigurator(root) {
    if (!root || root.dataset.noirInitialized === 'true') return;
    root.dataset.noirInitialized = 'true';

    var form = root.closest('form') || root.querySelector('form');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-noir-step]'));
    var totalSteps = steps.length;
    var progressFill = root.querySelector('[data-noir-progress-fill]');
    var progressText = root.querySelector('[data-noir-progress-text]');
    var progressBar = root.querySelector('[data-noir-progressbar]');
    var liveRegion = root.querySelector('[data-noir-live-region]');

    var textInput = root.querySelector('[data-noir-text-input]');
    var textCounter = root.querySelector('[data-noir-text-counter]');
    var maxChars = parseInt((textInput && textInput.getAttribute('maxlength')) || '20', 10);

    var previewText = root.querySelector('[data-noir-preview-text]');
    var previewStage = root.querySelector('[data-noir-preview-stage]');

    var styleRadios = Array.prototype.slice.call(root.querySelectorAll('[data-noir-style-radio]'));
    var customFields = root.querySelector('[data-noir-custom-fields]');

    var brandInput = root.querySelector('[data-noir-field="brand"]');
    var modelInput = root.querySelector('[data-noir-field="model"]');

    var qtyRadios = Array.prototype.slice.call(root.querySelectorAll('[data-noir-qty-radio]'));
    var agreeCheckbox = root.querySelector('[data-noir-agree]');

    var firstNameInput = root.querySelector('[data-noir-field="firstName"]');
    var lastNameInput = root.querySelector('[data-noir-field="lastName"]');
    var emailInput = root.querySelector('[data-noir-field="email"]');

    var submitBtn = root.querySelector('[data-noir-submit]');
    var bodyField = root.querySelector('[data-noir-body-field]');
    var urlField = root.querySelector('[data-noir-url-field]');
    var dateField = root.querySelector('[data-noir-date-field]');

    var currentStep = 1;
    var reachedSteps = {};

    function sanitizeText(value) {
      var withoutTags = value.split("<").join("").split(">").join("");
      var chars = withoutTags.split("");
      var cleaned = chars.filter(function (ch) {
        var code = ch.charCodeAt(0);
        return code >= 32 && code !== 127;
      });
      return cleaned.join("");
    }

    function setFieldError(input, message) {
      if (!input) return;
      var errorEl = root.querySelector('[data-noir-error-for="' + input.id + '"]');
      if (errorEl) {
        errorEl.textContent = message || '';
      }
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function showStep(n, opts) {
      opts = opts || {};
      n = Math.min(Math.max(n, 1), totalSteps);
      currentStep = n;
      steps.forEach(function (stepEl) {
        var stepNum = parseInt(stepEl.getAttribute('data-noir-step'), 10);
        var isActive = stepNum === n;
        stepEl.hidden = !isActive;
      });
      updateProgress();
      if (n === 3) updateReviewSummary();
      if (!opts.silent) {
        var heading = steps[n - 1] && steps[n - 1].querySelector('[data-noir-step-heading]');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: false });
        }
        if (liveRegion) liveRegion.textContent = 'Stap ' + n + ' van ' + totalSteps;
        var stageWrap = root.closest('.noir-configurator-section') || root;
        if (window.innerWidth < 990) {
          var formEl = root.querySelector('[data-noir-form-anchor]');
          if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      if (!reachedSteps[n]) {
        reachedSteps[n] = true;
        if (n === 3) trackEvent('personalizer_review_reached');
      }
      persistDraft();
    }

    function updateProgress() {
      var pct = Math.round((currentStep / totalSteps) * 100);
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressText) progressText.textContent = currentStep + ' van ' + totalSteps;
      if (progressBar) progressBar.setAttribute('aria-valuenow', String(currentStep));
    }

    function validateStep1() {
      var raw = textInput.value.trim();
      if (!raw) {
        setFieldError(textInput, textInput.getAttribute('data-error-required') || 'Vul een tekst in voor je plaathouder.');
        return false;
      }
      if (raw.length > maxChars) {
        setFieldError(textInput, 'Maximaal ' + maxChars + ' tekens toegestaan.');
        return false;
      }
      setFieldError(textInput, '');
      return true;
    }

    function validateStep2() {
      var valid = true;
      if (brandInput && !brandInput.value.trim()) {
        setFieldError(brandInput, 'Vul je automerk in.');
        valid = false;
      } else if (brandInput) {
        setFieldError(brandInput, '');
      }
      if (modelInput && !modelInput.value.trim()) {
        setFieldError(modelInput, 'Vul je model in.');
        valid = false;
      } else if (modelInput) {
        setFieldError(modelInput, '');
      }
      return valid;
    }

    function validateStep3() {
      if (agreeCheckbox && !agreeCheckbox.checked) {
        setFieldError(agreeCheckbox, 'Bevestig dit om verder te gaan.');
        return false;
      }
      if (agreeCheckbox) setFieldError(agreeCheckbox, '');
      return true;
    }

    function validateStep4() {
      var valid = true;
      if (firstNameInput && !firstNameInput.value.trim()) {
        setFieldError(firstNameInput, 'Vul je voornaam in.');
        valid = false;
      } else if (firstNameInput) {
        setFieldError(firstNameInput, '');
      }
      if (lastNameInput && !lastNameInput.value.trim()) {
        setFieldError(lastNameInput, 'Vul je achternaam in.');
        valid = false;
      } else if (lastNameInput) {
        setFieldError(lastNameInput, '');
      }
      var emailVal = emailInput ? emailInput.value.trim() : '';
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
      if (!emailOk) {
        setFieldError(emailInput, 'Vul een geldig e-mailadres in.');
        valid = false;
      } else if (emailInput) {
        setFieldError(emailInput, '');
      }
      return valid;
    }

    function getSelectedStyle() {
      return styleRadios.filter(function (r) { return r.checked; })[0];
    }

    function getSelectedStyleLabel() {
      var selected = getSelectedStyle();
      return selected ? selected.value : '';
    }

    function updatePreview() {
      if (!previewText) return;
      var raw = textInput ? textInput.value.trim() : '';
      var placeholder = previewText.getAttribute('data-noir-placeholder') || 'JOUW TEKST';
      var display = raw ? raw.toUpperCase() : placeholder;
      previewText.textContent = display;
      previewText.classList.toggle('is-placeholder', !raw);
      var len = display.length;
      var size = 3.4;
      if (len > 8) size = Math.max(1.3, 3.4 - (len - 8) * 0.14);
      previewText.style.fontSize = size + 'rem';
      var selected = getSelectedStyle();
      var styleKey = selected ? selected.getAttribute('data-style-key') : 'stealth-black';
      if (previewStage) previewStage.setAttribute('data-style', styleKey);
    }

    function updateCounter() {
      if (!textCounter || !textInput) return;
      textCounter.textContent = textInput.value.length + ' / ' + maxChars;
    }

    function updateNextEnabled() {
      var nextBtn1 = root.querySelector('[data-noir-next="1"]');
      if (nextBtn1 && textInput) {
        var val = textInput.value.trim();
        nextBtn1.disabled = !(val.length > 0 && val.length <= maxChars);
      }
    }

    function selectStyle(key) {
      styleRadios.forEach(function (r) {
        r.checked = r.getAttribute('data-style-key') === key;
      });
      root.querySelectorAll('[data-noir-style-card]').forEach(function (card) {
        var isSelected = card.getAttribute('data-noir-style-card') === key;
        card.classList.toggle('is-selected', isSelected);
      });
      if (customFields) customFields.hidden = key !== 'custom';
      updatePreview();
      persistDraft();
    }

    function getExtraWishesText() {
      var selected = getSelectedStyle();
      if (selected && selected.getAttribute('data-style-key') === 'custom') {
        var desc = root.querySelector('[data-noir-field="customDescription"]');
        return desc ? desc.value.trim() : '';
      }
      return '';
    }

    function updateReviewSummary() {
      var yearInput = root.querySelector('[data-noir-field="year"]');
      var values = {
        text: textInput ? textInput.value.trim() : '',
        style: getSelectedStyleLabel(),
        brand: brandInput ? brandInput.value.trim() : '',
        model: modelInput ? modelInput.value.trim() : '',
        year: yearInput ? yearInput.value.trim() : '',
        extra: getExtraWishesText()
      };
      Object.keys(values).forEach(function (key) {
        var el = root.querySelector('[data-noir-review="' + key + '"]');
        if (el) el.textContent = values[key] || '—';
      });
      var qty = qtyRadios.filter(function (r) { return r.checked; })[0];
      var qtyEl = root.querySelector('[data-noir-review="qty"]');
      if (qtyEl) {
        var qtyLabel = qty ? qty.closest('[data-noir-qty-card]').querySelector('[data-noir-qty-label]') : null;
        qtyEl.textContent = qtyLabel ? qtyLabel.textContent.trim() : '—';
      }
    }

    function persistDraft() {
      try {
        var data = { step: currentStep, fields: {} };
        root.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (el) {
          if (el.type === 'checkbox') data.fields[el.name] = el.checked;
          else if (el.type === 'radio') {
            if (el.checked) data.fields[el.name] = el.value;
          } else {
            data.fields[el.name] = el.value;
          }
        });
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        /* storage unavailable */
      }
    }

    function restoreDraft() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var data = JSON.parse(raw);
        if (!data || !data.fields) return;
        Object.keys(data.fields).forEach(function (name) {
          var els = root.querySelectorAll('[name="' + cssEscape(name) + '"]');
          els.forEach(function (el) {
            if (el.type === 'checkbox') el.checked = !!data.fields[name];
            else if (el.type === 'radio') el.checked = el.value === data.fields[name];
            else el.value = data.fields[name];
          });
        });
        var styleSelected = getSelectedStyle();
        if (styleSelected) selectStyle(styleSelected.getAttribute('data-style-key'));
        qtyRadios.forEach(function (r) {
          var card = r.closest('[data-noir-qty-card]');
          if (card) card.classList.toggle('is-selected', r.checked);
        });
        updateCounter();
        updatePreview();
        updateNextEnabled();
        if (root.dataset.noirHasError === 'true' && data.step) {
          showStep(Math.min(data.step, totalSteps), { silent: true });
        }
      } catch (e) {
        /* ignore malformed storage */
      }
    }

    function buildSummary() {
      var lines = [];
      lines.push('Gewenste tekst: ' + (textInput ? textInput.value.trim() : ''));
      lines.push('Stijl: ' + getSelectedStyleLabel());
      lines.push('Automerk: ' + (brandInput ? brandInput.value.trim() : ''));
      lines.push('Model: ' + (modelInput ? modelInput.value.trim() : ''));
      var yearInput = root.querySelector('[data-noir-field="year"]');
      lines.push('Bouwjaar: ' + (yearInput ? yearInput.value.trim() : '(niet opgegeven)'));
      var qty = qtyRadios.filter(function (r) { return r.checked; })[0];
      lines.push('Aantal: ' + (qty ? qty.value : ''));
      var extra = getExtraWishesText();
      if (extra) lines.push('Extra wensen: ' + extra);
      var linkInput = root.querySelector('[data-noir-field="customLink"]');
      if (linkInput && linkInput.value.trim()) lines.push('Link naar logo/voorbeeld: ' + linkInput.value.trim());
      var whatsapp = root.querySelector('[data-noir-field="whatsapp"]');
      lines.push('WhatsApp contact gewenst: ' + (whatsapp && whatsapp.checked ? 'Ja' : 'Nee'));
      return lines.join('\n');
    }

    /* events */
    if (textInput) {
      textInput.addEventListener('input', function () {
        var cleaned = sanitizeText(textInput.value);
        if (cleaned !== textInput.value) textInput.value = cleaned;
        updateCounter();
        updatePreview();
        updateNextEnabled();
        setFieldError(textInput, '');
      });
      var textTracked = false;
      textInput.addEventListener('blur', function () {
        if (!textTracked && textInput.value.trim()) {
          trackEvent('personalizer_text_entered');
          textTracked = true;
        }
      });
    }

    styleRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          var key = radio.getAttribute('data-style-key');
          selectStyle(key);
          trackEvent('personalizer_style_selected', { style: key });
        }
      });
    });

    root.querySelectorAll('[data-noir-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = parseInt(btn.getAttribute('data-noir-next'), 10);
        var valid = true;
        if (from === 1) valid = validateStep1();
        if (from === 2) valid = validateStep2();
        if (from === 3) valid = validateStep3();
        if (valid) showStep(from + 1);
      });
    });

    root.querySelectorAll('[data-noir-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = parseInt(btn.getAttribute('data-noir-prev'), 10);
        showStep(from - 1);
      });
    });

    root.querySelectorAll('[data-noir-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(parseInt(btn.getAttribute('data-noir-goto'), 10));
      });
    });

    qtyRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('[data-noir-qty-card]').forEach(function (card) {
          card.classList.toggle('is-selected', card.querySelector('[data-noir-qty-radio]') === radio);
        });
        persistDraft();
      });
    });

    if (agreeCheckbox) {
      agreeCheckbox.addEventListener('change', function () {
        setFieldError(agreeCheckbox, '');
        persistDraft();
      });
    }

    root.querySelectorAll('input, textarea, select').forEach(function (el) {
      el.addEventListener('change', persistDraft);
    });

    var submitted = false;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (submitted) {
          e.preventDefault();
          return;
        }
        if (currentStep === 4 && !validateStep4()) {
          e.preventDefault();
          return;
        }
        if (bodyField) bodyField.value = buildSummary();
        if (urlField) urlField.value = window.location.href;
        if (dateField) dateField.value = new Date().toLocaleString('nl-BE');
        persistDraft();
        submitted = true;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');
          var label = submitBtn.querySelector('[data-noir-submit-label]');
          if (label) label.textContent = submitBtn.getAttribute('data-noir-loading-text') || 'Aanvraag wordt verstuurd…';
        }
        trackEvent('personalizer_submitted');
      });
    }

    /* init */
    updateCounter();
    updatePreview();
    updateNextEnabled();
    restoreDraft();
    if (root.dataset.noirHasError !== 'true') {
      showStep(1, { silent: true });
    } else {
      showStep(currentStep || 1, { silent: true });
    }
    trackEvent('personalizer_started');
  }

  function setSuccessText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value && value.trim() ? value : '—';
  }

  function initSuccessScreen(root) {
    if (!root || root.dataset.noirSuccessInitialized === 'true') return;
    root.dataset.noirSuccessInitialized = 'true';
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var data = JSON.parse(raw);
        var fields = data && data.fields ? data.fields : {};
        setSuccessText(root, '[data-noir-success-text]', fields['contact[Gewenste tekst]']);
        setSuccessText(root, '[data-noir-success-style]', fields['contact[Stijl]']);
        var brand = fields['contact[Automerk]'] || '';
        var model = fields['contact[Model]'] || '';
        var brandModel = (brand + ' ' + model).replace(/^\s+|\s+$/g, '');
        setSuccessText(root, '[data-noir-success-brandmodel]', brandModel);
        setSuccessText(root, '[data-noir-success-qty]', fields['contact[Aantal]']);
      }
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initConfigurator);
    document.querySelectorAll('[data-noir-success]').forEach(initSuccessScreen);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector(ROOT_SELECTOR) : null;
    if (root) {
      root.dataset.noirInitialized = 'false';
      initConfigurator(root);
    }
  });
})();
